import {css, media, tokens} from '@sail/ui';
import {helmTokens} from '@sail/helm';

export const styles = {
  footerNavContainerUnprocessedCss: css({
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    rowGap: `${tokens.space.large}`,
    [media.up(tokens.viewport.small)]: {
      gridTemplateColumns: 'repeat(4, 1fr)',
    },
  }),
  footerColumnContainer: css({
    stack: 'y',
    gap: 'large',
    paddingX: 'medium',
    alignY: 'stretch',
    [media.up(tokens.viewport.small)]: {
      alignY: 'top',
    },
  }),
  footerColumnContainerUnprocessedCss: css({
    ':last-child': {
      gridColumn: 'span 2',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
    },
    [media.up(tokens.viewport.small)]: {
      ':last-child': {
        gridTemplateColumns: '1fr',
        gridColumn: 'span 1',
        alignContent: 'start',
      },
    },
  }),
  footerBrandAndGlobalization: css({
    stack: 'y',
    gap: 'xsmall',
    alignX: 'start',
  }),
  footerBrandColumn: css({
    height: 'auto',
    distribute: 'packed',
    gap: 'small',
    [media.up(tokens.viewport.small)]: {
      distribute: 'space-between',
      height: '100%',
    },
  }),
  footerBrandColumnUnprocessedCss: css({
    gridColumn: 'span 2',
    [media.up(tokens.viewport.small)]: {
      gridColumn: 'span 1',
    },
  }),
  footerStripeLogo: css({
    [media.query('(pointer: fine)')]: {
      transition: `opacity ${helmTokens.transition.hover}`,
      ':hover': {
        opacity: 0.6,
      },
    },
  }),
  footerCopyrightNotice: [
    css({
      margin: 'space.0',
      font: 'body.medium',
      textColor: 'text',
    }),
    css({
      letterSpacing: `${helmTokens.letterSpacing.large}`,
    }),
  ],
};
